export default __webpack_public_path__ + "static/media/ellipse-disabled.82c3b314.svg";